import { render, staticRenderFns } from "./NotAssNewBreadcrumbButton.component.vue?vue&type=template&id=d999f97e&scoped=true&"
import script from "./NotAssNewBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./NotAssNewBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./NotAssNewBreadcrumbButton.component.vue?vue&type=style&index=0&id=d999f97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d999f97e",
  null
  
)

export default component.exports